import { render, staticRenderFns } from "./TaggingListGrid.vue?vue&type=template&id=5feb8a44"
import script from "./TaggingListGrid.vue?vue&type=script&lang=js"
export * from "./TaggingListGrid.vue?vue&type=script&lang=js"
import style0 from "./TaggingListGrid.vue?vue&type=style&index=0&id=5feb8a44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports